jQuery(document).ready(function($){
	$('.sc-login-form .reset-password-link').on('click', function(e){
		e.preventDefault();

		const parentDiv = $(this).closest('.sc-login-form');
		parentDiv.addClass('show-password-reset');
	});

	$('.sc-login-form .login-form-link').on('click', function(e){
		e.preventDefault();

		const parentDiv = $(this).closest('.sc-login-form');
		parentDiv.removeClass('show-password-reset');
	});
});